import type { PublicBookingDto } from '@shared/core/bookings'

export interface RescheduleInitialData {
  appointmentType: string
  timezone: string
}

export function getInitialDataFromBooking(booking: PublicBookingDto): RescheduleInitialData {
  return {
    appointmentType: booking.appointment_type_id,
    timezone: booking.customer_tz || booking.provider_tz || 'UTC',
  }
}

export function getBookingDetailsUrlAfterReschedule(bookingId: string): string {
  return `/bookings/${bookingId}?rescheduled=1`
}

export function hasRescheduleError(
  booking: PublicBookingDto | null | undefined,
  bookingId: string | undefined,
): boolean {
  return !booking && !!bookingId
}
